import { useState } from "react"
import { Link } from "react-router-dom"

const BottomBar = () => {
  const [hoveredLink, setHoveredLink] = useState<string | null>(null)

  return (
    <div className="border-t border-white/10 backdrop-blur-sm">
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row justify-between items-center text-xs sm:text-sm text-gray-400 gap-4">
          <p className="flex items-center gap-2 text-center md:text-left">
            <span className="text-amber-500 font-bold">©</span>
            <span>2025 Travel Warehouse, Inc. All rights reserved.</span>
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <Link
              to="/privacy-policy"
              className="transition-all duration-300 hover:text-orange-400 relative group"
              onMouseEnter={() => setHoveredLink('privacy')}
              onMouseLeave={() => setHoveredLink(null)}
            >
              Privacy Policy
              <span className={`absolute bottom-0 left-0 h-0.5 bg-amber-500 transition-all duration-300 ${
                hoveredLink === 'privacy' ? 'w-full' : 'w-0'
              }`}></span>
            </Link>
            <Link
              to="/terms-of-service"
              className="transition-all duration-300 hover:text-amber-500 relative group"
              onMouseEnter={() => setHoveredLink('terms')}
              onMouseLeave={() => setHoveredLink(null)}
            >
              Terms of Service
              <span className={`absolute bottom-0 left-0 h-0.5 bg-amber-500 transition-all duration-300 ${
                hoveredLink === 'terms' ? 'w-full' : 'w-0'
              }`}></span>
            </Link>
            <a
              href="#"
              className="transition-all duration-300 hover:text-amber-500 relative group"
              onMouseEnter={() => setHoveredLink('sitemap')}
              onMouseLeave={() => setHoveredLink(null)}
            >
              Sitemap
              <span className={`absolute bottom-0 left-0 h-0.5 bg-amber-500 transition-all duration-300 ${
                hoveredLink === 'sitemap' ? 'w-full' : 'w-0'
              }`}></span>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default BottomBar